import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import SEO from '../../components/common/SEO';

const ShippingInfo = () => (
  <div className="min-h-screen flex flex-col">
    <SEO
      title="Shipping Information"
      description="Learn about Elixir's shipping policies, delivery times, and worldwide shipping for Mediterranean honey."
      keywords="Elixir shipping, honey delivery, Mediterranean honey shipping, shipping policy, worldwide honey delivery"
    />
    <Header />
    <main className="flex-grow bg-white py-12 px-4 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold text-[#d4af37] mb-6">Shipping Information</h1>
      <p className="mb-4">Elixir is proud to offer fast and reliable shipping for all our Mediterranean honey products. We ship worldwide from our facility in Tunisia.</p>
      <h2 className="text-xl font-semibold mt-6 mb-2">Shipping Methods & Times</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Orders are processed within 1-2 business days.</li>
        <li>Standard shipping: 5-10 business days (Europe), 7-15 business days (International).</li>
        <li>Express shipping options available at checkout.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">Shipping Costs</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Shipping costs are calculated at checkout based on your location and order weight.</li>
        <li>Free shipping on orders over €100 (Europe only).</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">Order Tracking</h2>
      <p className="mb-4">You will receive a tracking number by email once your order has shipped.</p>
      <h2 className="text-xl font-semibold mt-6 mb-2">Questions?</h2>
      <p>Contact our support team at <a href="mailto:team@elixir-honey.com" className="text-[#d4af37] underline">team@elixir-honey.com</a> for any shipping inquiries.</p>
    </main>
    <Footer />
  </div>
);

export default ShippingInfo; 